import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'routes.BankCard.AddSessionBankCard.title',
    defaultMessage: 'Add Payment Card',
    description: '备注: 页面title',
  },
  message1: {
    id: 'routes.BankCard.AddSessionBankCard.message1',
    defaultMessage: 'CVV invalid or missing.',
    description: '提示信息1',
  },
  message2: {
    id: 'routes.BankCard.AddSessionBankCard.message2',
    defaultMessage: 'Card number invalid or missing.',
    description: '提示信息2',
  },
  message3: {
    id: 'routes.BankCard.AddSessionBankCard.message3',
    defaultMessage: 'Expiry year invalid or missing.',
    description: '提示信息3',
  },
  message4: {
    id: 'routes.BankCard.AddSessionBankCard.message4',
    defaultMessage: 'Expiry month invalid or missing.',
    description: '提示信息4',
  },
  message5: {
    id: 'routes.BankCard.AddSessionBankCard.message5',
    defaultMessage: 'CVV invalid.',
    description: '提示信息5',
  },
  message6: {
    id: 'routes.BankCard.AddSessionBankCard.message6',
    defaultMessage: 'Session update failed with request timeout: ',
    description: '提示信息6',
  },
  message7: {
    id: 'routes.BankCard.AddSessionBankCard.message7',
    defaultMessage: 'Session update failed with system error: ',
    description: '提示信息7',
  },
  message8: {
    id: 'routes.BankCard.AddSessionBankCard.message8',
    defaultMessage: 'Session update failed:',
    description: '提示信息8',
  },
  message9: {
    id: 'routes.BankCard.AddSessionBankCard.message9',
    defaultMessage: 'Loading...',
    description: '提示信息9',
  },
  alertTitle: {
    id: 'routes.BankCard.AddSessionBankCard.alertTitle',
    defaultMessage: 'Failed！',
    description: 'alert: Title',
  },
  alertBtnBack: {
    id: 'routes.BankCard.AddSessionBankCard.alertBtnBack',
    defaultMessage: 'BACK',
    description: 'alert: button back',
  },
  alertBtnRemain: {
    id: 'routes.BankCard.AddSessionBankCard.alertBtnRemain',
    defaultMessage: 'REMAIN',
    description: 'alert: button remain',
  },
  tips: {
    id: 'routes.BankCard.AddSessionBankCard.tips',
    defaultMessage: 'Tip: Only debit cards are supported.',
    description: 'tips',
  },
  listCardNumberLabel: {
    id: 'routes.BankCard.AddSessionBankCard.listCardNumberLabel',
    defaultMessage: 'Card Number',
    description: 'Card Number: label',
  },
  listCardNumberPlaceholder: {
    id: 'routes.BankCard.AddSessionBankCard.listCardNumberPlaceholder',
    defaultMessage: 'Enter your Card number',
    description: 'Card Number: Placeholder',
  },
  listExpireLabel: {
    id: 'routes.BankCard.AddSessionBankCard.listExpireLabel',
    defaultMessage: 'Expiry',
    description: 'Expiry: label',
  },
  listCVVLabel: {
    id: 'routes.BankCard.AddSessionBankCard.listCVVLabel',
    defaultMessage: 'CVV',
    description: 'CVV: label',
  },
  listCVVPlaceholder: {
    id: 'routes.BankCard.AddSessionBankCard.listCVVPlaceholder',
    defaultMessage: '3-dight',
    description: 'CVV: Placeholder',
  },
  listCardHolderNameLabel: {
    id: 'routes.BankCard.AddSessionBankCard.listCardHolderNameLabel',
    defaultMessage: 'Card Holder Name',
    description: 'Card Holder Name: label',
  },
  listCardHolderNamePlaceholder: {
    id: 'routes.BankCard.AddSessionBankCard.listCardHolderNamePlaceholder',
    defaultMessage: 'Fill in your card holder name',
    description: 'Card Holder Name: Placeholder',
  },
  listEmailNameLabel: {
    id: 'routes.BankCard.AddSessionBankCard.listEmailNameLabel',
    defaultMessage: 'Email Address <small class="gray">(optional)</small>',
    description: 'Email: label',
  },
  listEmailNamePlaceholder: {
    id: 'routes.BankCard.AddSessionBankCard.listEmailNamePlaceholder',
    defaultMessage: 'Enter your Email Address',
    description: 'Email: Placeholder',
  },
  view: {
    id: 'routes.BankCard.AddSessionBankCard.view',
    defaultMessage: 'Saved your card to wallet. I have read and agreed to ',
    description: 'View',
  },
  serviceAgreement: {
    id: 'routes.BankCard.AddSessionBankCard.serviceAgreement',
    defaultMessage: 'Bank Card Agreement',
    description: 'Service Agreement',
  },
  bottomTips: {
    id: 'routes.BankCard.AddSessionBankCard.bottomTips',
    defaultMessage: 'For bank payment only',
    description: 'bottom Tips',
  },
  processing: {
    id: 'routes.BankCard.AddSessionBankCard.processing',
    defaultMessage: 'PROCESSING',
    description: '备注: 处理中',
  },
  description: {
    id: 'routes.BankCard.AddSessionBankCard.description',
    defaultMessage: 'This card will be saved after your bank authentication.',
    description: '备注: 处理中提示',
  },
  ok: {
    id: 'routes.BankCard.AddSessionBankCard.ok',
    defaultMessage: 'OK',
    description: '备注: 按钮',
  },
})
